import {createSelector} from 'reselect'

const getWelcomeState = state => state.welcome

export const getLoading = createSelector(
    getWelcomeState,
    state => state.loading
)

export const getShowExternalContent = createSelector(
    getWelcomeState,
    state => state.showExternalContent
)

export const getDemoDataStage = createSelector(
    getWelcomeState,
    state => state.demoDataStage
)

export const getUrl = createSelector(
    getWelcomeState,
    state => state.url
)

export const getWidth = createSelector(
    getWelcomeState,
    state => state.size.width
)

export const getHeight = createSelector(
    getWelcomeState,
    state => state.size.height
)

export const getLoadExternalWelcomeScreen = createSelector(
    getWelcomeState,
    state => state.loadExternalWelcomeScreen
)


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/selectors.js